import { Navigate, useOutlet } from "react-router-dom";
import { mostraAlertaError } from "../componentes/alerts/sweetAlert";
import { useContextUsuario } from "../contexto/usuario/UsuarioContext";

export const PedidoLayout = () => {
  const outlet = useOutlet();
  const { usuario } = useContextUsuario();
  if (usuario.tipo != "Empleado") {
    mostraAlertaError("No tienes permitido acceder a este sitio");
    return <Navigate to="/login" />;
  }
  return outlet;
};
